import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Scoreboard = ({
  teamName,
  score,
  onAddPoint,
  color,
  side,
  disabled,
  testIdPrefix,
}) => {
  return (
    <div
      className="flex flex-col items-stretch gap-3 w-full"
      data-testid={`${testIdPrefix}-scoreboard`}
    >
      <div
        className="border-4 border-[#111111] shadow-brutal-md p-5 flex flex-col items-center"
        style={{ backgroundColor: color }}
      >
        <span className="font-mono-debate font-bold uppercase text-xs tracking-[0.25em] text-white/90 mb-1">
          {side === "left" ? "◤ Team 1" : "Team 2 ◥"}
        </span>
        <h3
          className="font-anton uppercase text-3xl md:text-4xl text-white text-center leading-tight break-words"
          data-testid={`${testIdPrefix}-name`}
        >
          {teamName}
        </h3>

        <div className="my-3 w-full h-[3px] bg-white/40" />

        <AnimatePresence mode="wait">
          <motion.div
            key={score}
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: [1, 1.4, 1], opacity: 1 }}
            exit={{ scale: 0.5, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="font-anton text-7xl md:text-8xl text-[#FFF4E0] leading-none"
            style={{ textShadow: "4px 4px 0px #111111" }}
            data-testid={`${testIdPrefix}-score`}
          >
            {score}
          </motion.div>
        </AnimatePresence>
        <span className="font-mono-debate text-[11px] uppercase tracking-widest text-white/70 mt-1">
          / 10
        </span>
      </div>

      <button
        onClick={onAddPoint}
        disabled={disabled}
        data-testid={`${testIdPrefix}-add-point-btn`}
        className="btn-brutal-press bg-[#FFD700] text-[#111111] border-4 border-[#111111] shadow-brutal-sm font-anton uppercase text-xl md:text-2xl py-3 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        + Point
      </button>
    </div>
  );
};
